import './App.css';
import Search from './Search/Search';
import { Container, Col, Row } from 'react-bootstrap';

function App() {
  return (
    <div className="App">
      <Container fluid>
        <Search></Search>
      </Container>
    </div>
  );
}

export default App;
